import { Component, inject, Input, OnInit } from '@angular/core';
import { IRegisteredAddress } from '../../../../models/registered-address.model';
import { EstimationTunnelService } from '../../../../services/estimation-tunnel.service';
import { ITransportConfiguration } from '../../../../models/transport-configuration.model';
import { TransportConfigurationService } from '../../../../services/transport-configuration.service';
import { AddressCardOptions } from '../../../shared/ui/cards/address-card/address-card-options.model';
import { AccountService } from '../../../../services/account.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { TransportFormGroup } from '../../../../models/forms/TransportFormGroup';
import { TransportStep } from '../../../../models/enums/transport-step.enum';
import { Transporter } from '../../../../models/transporter.model';
import { CurrentDataService } from '../../../../services/current-data-service';
import { Transport } from '../../../../models/transport.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'jhi-estimation-pickup-step',
  templateUrl: './estimation-pickup-step.component.html',
})
export class EstimationPickupStepComponent implements OnInit {
  readonly #estimationService = inject(EstimationTunnelService);
  readonly #accountService = inject(AccountService);
  readonly #transportConfigurationService = inject(TransportConfigurationService);
  readonly #spinnerService = inject(NgxSpinnerService);
  readonly #currentDataService = inject(CurrentDataService);

  @Input() readonly transport!: Transport;
  @Input() transportForm!: TransportFormGroup;
  @Input() isAuthenticated = false;

  public selectedAddress?: IRegisteredAddress;
  public isUser?: boolean;
  public transportConfiguration?: ITransportConfiguration;
  public addressOptions?: AddressCardOptions;
  public transporter?: Transporter;

  public ngOnInit(): void {
    this.#estimationService.scrollToTop();
    this.isUser = this.#accountService.hasAnyAuthority('ROLE_USER');
    this.transportForm.controls.offerId?.valueChanges.subscribe((newOfferId: number) => this.initConfiguration(newOfferId));
    this.initConfiguration(this.transport.offerId!);
    this.#currentDataService.getCurrentTransporter().subscribe((transporter: Transporter | undefined) => (this.transporter = transporter));
  }

  public initConfiguration(offerId: number): void {
    this.#spinnerService.show().then();
    this.#transportConfigurationService
      .getParams(offerId, TransportStep.PICKUP)
      .subscribe(config => {
        this.transportConfiguration = config;
        this.addressOptions = {
          withBillAddress: false,
          withFullName: true,
          withAdditional: true,
          withDeliveryOutOfEU: config.vatExonerationAllowed,
          withFloorNumber: config.addressFloorNumberAllowed,
        };
      })
      .add(() => this.#spinnerService.hide());
  }

  public selectRegisteredAddress(registeredAddress?: IRegisteredAddress): void {
    if (registeredAddress) {
      this.transportForm.updateFormFromRegisteredAddress(registeredAddress, true);
      this.transportForm.getAngularForm().updateValueAndValidity();
    }
    this.selectedAddress = registeredAddress;
  }

  public selectAccessConstraint(accessConstraint?: string): void {
    if (accessConstraint) {
      this.transportForm.updateAccessConstraint(accessConstraint, true);
      this.transportForm.getAngularForm().updateValueAndValidity();
    }
  }

  public selectLoadingConstraint(loadingConstraint?: string): void {
    if (loadingConstraint) {
      this.transportForm.updateLoadingConstraint(loadingConstraint, true);
      this.transportForm.getAngularForm().updateValueAndValidity();
    }
  }
}
